import React from 'react';

import Visibility from '@material-ui/icons/VisibilityOutlined';
import VisibilityOff from '@material-ui/icons/VisibilityOffOutlined';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/components/customInputStyle';
import CustomInput from './CustomInput';
import withHover from 'components/withHoverHOC/withHover';

// @ts-ignore
const useStyles = makeStyles(styles);

const CustomPasswordInput = (props: types.inputs.ICustomInput) => {
	let { inputProps } = props;
	inputProps = inputProps || {};

	const classes = useStyles();

	const [visible, setVisible] = React.useState(false);
	return (
		<CustomInput
			{...props}
			inputProps={{
				...inputProps,
				type: visible ? 'text' : 'password',
				endAdornment: (
					<InputAdornment position="end">
						<IconButton
							aria-label="toggle password visibility"
							onClick={() => setVisible((value) => !value)}
							className={classes.visibilityIcon}
						>
							{visible ? <VisibilityOff /> : <Visibility />}
						</IconButton>
					</InputAdornment>
				),
			}}
		/>
	);
};

export default withHover(CustomPasswordInput);
